export const DB_SORT_DIRECTIONS = {
    DESC: "desc",
    ASC: "asc"
};

export enum ROLES {
    SUPER_ADMIN = 'Super Admin',
    SITE_ADMIN = 'Admin',
    ORG = 'Organization',
    ORG_ADMIN = 'Organization Admin',
    ORG_USER = 'Organization User',
    INDIVIDUAL_USER = 'Individual User'
}
export const CURRENCYSYMBOL = 'AED ';

export const TABLE_ROW_WIDTH = 50;
export const TABLE_ROW_WIDTH_RELATED = 200;

export const AllowedRoles = [ROLES.SUPER_ADMIN, ROLES.SITE_ADMIN];
export const ClientAdminRoles = [ROLES.ORG_ADMIN, ROLES.INDIVIDUAL_USER];
export const ClientUserRoles = [ROLES.ORG_USER];
export enum TEMPLATE_TYPES {
    EMAIL = 'email',
    PDF = 'pdf'
}
export const templateTypes = [{
    label: 'PDF',
    value: 'pdf',
}, {
    label: 'Email',
    value: 'email',
}]

export const RupeeSymbol = '₹';